import { useEffect } from "react";
import styles from "./BillingHistory.module.css";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import getBilligHistoryData from "../../../store/subscriptions/billingHistory/BilligHistory";
import Loader from "../../spinner/Loader";
import { formatDateByLanguage } from "../../../utils/time";
import { PLAN_TYPES } from "../../../utils/helpers/subscriptions/plans";

export default function BillingHistory({ lang, t, userPlan }) {
  const dispatch = useDispatch();
  const billingHistoryData = useSelector((state) => state.billingHistory);
  const token = Cookies.get("auth_token");

  useEffect(() => {
    if (token) {
      dispatch(getBilligHistoryData(token));
    }
  }, [dispatch, token]);

  const billingHistory = billingHistoryData?.billingHistory;
  const transactionLabel = lang === "am" ? t("transaction") : billingHistory?.length > 1 ? t("transactions") : t("transaction");
  const totalSpent = billingHistory?.reduce((sum, item) => sum + (item?.price ?? 0), 0);

  return (
    <div className={styles.container}>
      <div className={styles.card}>

        <div className={styles.header}>
          <div className={styles.headerLeft}>
            <div className={styles.headerIcon}>
              <img src="/assets/subscriptions/receipt.svg" alt="" width={16} height={16} />
            </div>
            <div>
              <h2 className={styles.title}>{t("billing_history")}</h2>
              <p className={styles.subtitle}>
                {billingHistory?.length} {transactionLabel}
              </p>
            </div>
          </div>
        </div>

        {billingHistory === null ? (
          <Loader />
        ) : (
          <>
            <div className={styles.tableWrap}>
              <div className={styles.tableHead}>
                <span>{t("date")}</span>
                <span>{t("plan")}</span>
                <span>{t("amount")}</span>
              </div>
              <div className={styles.tableBody}>
                {billingHistory.length === 0 ? (
                  <div className={styles.emptyState}>
                    <img
                      src="/assets/subscriptions/receipt.svg"
                      alt=""
                      width={32}
                      height={32}
                      className={styles.emptyIcon}
                    />
                    <p className={styles.emptyText}>{t("no_data")}</p>
                  </div>
                ) : (
                  billingHistory?.map((item, i) => (
                    <div
                      className={styles.tableRow}
                      key={i}
                      style={{ animationDelay: `${i * 60}ms` }}
                    >
                      <span className={styles.cell}>
                        {formatDateByLanguage(item?.purchaseDate, lang)}
                      </span>
                      <span className={styles.planCell}>
                        {item?.plan === PLAN_TYPES.FAMILY ? t('vinni_plus_family') : t(item?.plan?.toLowerCase())}
                        <span className={styles.period}>({t(item.period)})</span>
                      </span>
                      <span className={styles.amountCell}>
                        {item.amount === 0 ? (
                          <span className={styles.freeTag}>{t("free")}</span>
                        ) : (
                          `${item?.price ? `$${item.price.toFixed(2)}` : t('not_provided')}`
                        )}
                      </span>
                    </div>
                  ))
                )}
              </div>
            </div>
            <div className={styles.totalRow}>
              <span />
              <span />
              <div className={styles.totalAmount}>
                <span>{t("total")}</span>
                <span>${totalSpent?.toFixed(2)}</span>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}